export function isSafari() {
  const userAgent = navigator.userAgent.toLowerCase();
  return userAgent.includes('safari') && !userAgent.includes('chrome') && !userAgent.includes('android');
}

export function supportLegacyBrowsers() {
  let isV13Safari = false;
  if (isSafari()) {
    const versionMatch = navigator.userAgent.toLowerCase().match(/version\/([\d]+)/i);
    if (versionMatch && versionMatch.length >= 2) {
      const version = versionMatch[1];
      isV13Safari = version === '13';
    }
  }

  // Workaround for V13 Safari
  // Issue: flex container height is not calculated properly
  if (isV13Safari) {
    const style = document.createElement('style');
    style.innerHTML = '.ms-Stack > .ms-Stack { flex-shrink: 0; }';
    document.head.appendChild(style);
  }
}
